import React from 'react'
import LinkBox from './LinkBox'
import styles from '../CollectionOfLinkBoxes.module.css'

function CollectionOfLinkBoxes(props) {
    const links = props.links;
    const linksAsReactElements = links.map(link => (
        <LinkBox item={link} key={link.url}></LinkBox>
    ));
    return (
        <div className={styles.linkCollection+ " linkCollection"}>
            <h2 className={styles.linkCollectionHeading}>{props.linkCollectionName}</h2>
            <p className={styles.linkCollectionDescription}>{props.linkCollectionDescription}</p>
            <div>{linksAsReactElements}</div>
        </div>
    )
}

export default CollectionOfLinkBoxes
